module.exports = __webpack_public_path__ + "img/arthur.124007ac.jpg";